import { Button, Divider, Flex, Modal, Typography } from 'antd'
import { useUnit } from 'effector-react'
import { BASE_URL } from 'src/pages/finSystem/debt/const'
import {
  debtListLoad,
  submitDeleteDebtFx,
} from 'src/pages/finSystem/debt/model'
import { Debt, ListRequest } from 'src/pages/finSystem/debt/types'

type Props = {
  item: Debt | null
  isOpen: boolean
  onClose: () => void
  filters: Record<string, any>
}

export const DeleteDebtModal = ({ isOpen, onClose, item, filters }: Props) => {
  const {
    id,
    walletIds,
    dateFrom,
    dateTo,
    userId,
    statuses,
    sorterField,
    page,
    pageSize,
  } = filters
  const { Text } = Typography
  const handleSubmit = async () => {
    try {
      await submitDeleteDebtFx({ url: `${BASE_URL}/${item?.id}` })

      onClose()
      debtListLoad({
        id,
        walletIds,
        dateFrom,
        dateTo,
        userId,
        statuses,
        sorterField,
        page,
        pageSize,
      } as ListRequest)
    } catch (error) {
      console.error(error)
    }
  }

  const loadingButton = useUnit(submitDeleteDebtFx.pending)

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Confirm Debt Deletion</div>}
      centered
      wrapClassName="ant_modal"
      width={400}
      maskClosable={false}
      open={isOpen}
      onCancel={onClose}
      footer={
        <Flex gap={8} justify="flex-end">
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="primary"
            danger
            loading={loadingButton}
            onClick={handleSubmit}
          >
            Delete
          </Button>
        </Flex>
      }
    >
      <Divider />
      <Text>
        Are you sure you want to delete Debt ID{' '}
        <Text style={{ color: 'var(--color-primary)' }}>{item?.id}</Text>{' '}
        belonging to User ID{' '}
        <Text style={{ color: 'var(--color-primary)' }}>{item?.id}</Text> in
        wallet{' '}
        <Text style={{ color: 'var(--color-primary)' }}>
          {item?.walletName}
        </Text>
        ? Deleting this debt will restore the wallet balance and remove the
        associated transaction from the wallet history. This action cannot be
        undone.
      </Text>
    </Modal>
  )
}
